var CreateCustomerTransmissionCtrl = function ($scope, previousState, customerModelService, $log, SettingsConstants, $state, createCustomerLoader, $q, errorRouterService, errorScreenService, ERR) {
    var vm = this;
    // this variables stores all listeners to the http error to have
    // possibility to unsubscribe when scope destroy event calls
    var httpErrorsListeners = [];
    httpErrorsListeners.push(errorRouterService.subscribe(function (err) {
        if (err && err.status == 500) {
            invokeGetItemError();
            return $q.when(true);
        }
    }, { resourceName: 'getTransmissions', status: '*' }));
    //trigger error screen
    function invokeGetItemError() {
        errorScreenService.error(true, ERR.CAN_NOT_GET_AVALIABLE_TRANSMISSION, {
            noFullScreen: true,
            template: 'template/errorscreens/can-not-get-avaliable-item',
            errorType: ERR.CAN_NOT_GET_AVALIABLE_TRANSMISSION,
            vinDecode: $scope.$parent.vinDecodeOptions
        });
    };
    //setVehicleTransmission
    //
    //@param {object} selected transmission object
    //
    //@description
    //Method calls when user select transmission
    vm.setVehicleTransmission = function (transmission) {
        var vehicle = customerModelService.getCurrentVehicle();
        if (vehicle) {
            vehicle.setTransmission(transmission);
            $scope.vehicleCreationData.selectedTransmission = transmission;
            $scope.ctrl.goToState($scope.ctrl.currentStateIndex + 1, $scope.vehicleCreationData.selectedTransmission);
        }
    };
    //selectDefault
    //
    //@description
    //Set default value to the transmission field when customer
    //pushes on 'I do not know' button
    vm.selectDefault = function () {
        var vehicle = customerModelService.getCurrentVehicle();
        if (vehicle) {
            $scope.setDefaultTransmission()
                .then(function () {
                    $state.go('overview');
                })
                .catch(function (err) {
                    $log.error('Something went wrong', err);
                });
        }
    }
    //init
    //
    //@description
    //Entry point into controller business logic
    function init() {
        var vehicle = customerModelService.getCurrentVehicle();
        if (vehicle) {
            var model = vehicle.getModel();
            $scope.vehicleCreationData.selectedModel = model;
            var loader = $q.defer();
            $scope.ctrl.goToOverviewState(model).then(function () {
                vm.selectDefault();
                loader.resolve();
            }).catch(function () {
                model.getTransmissions().then(function (transmissions) {
                    if (!transmissions || transmissions.length === 0) {
                        invokeGetItemError();
                        transmissions = [];
                    }
                    $scope.vehicleCreationData.transmissions = transmissions;
                    if (transmissions.length === 1) {
                        transmissions[0].autoSelected = true;
                        vm.setVehicleTransmission(transmissions[0]);
                    }
                }).catch(function (err) {
                    $log.error('Something went wrong', err);
                }).finally(function () {
                    loader.resolve();
                });
            });
            createCustomerLoader.addPromise(loader.promise);
        }
    };
    //unsubscribe all http exception listeners
    $scope.$on('$destroy', function () {
        httpErrorsListeners.forEach(function (id) {
            errorRouterService.unsubscribe(id);
        });
    });
    //start the controller
    init();
};
CreateCustomerTransmissionCtrl.$inject = ['$scope', 'previousState', 'customerModelService', '$log', 'SettingsConstants', '$state', 'createCustomerLoader', '$q', 'errorRouterService', 'errorScreenService', 'errors'];

module.exports = CreateCustomerTransmissionCtrl;
